module.exports = __webpack_public_path__ + "img/send-resume.9fa11fea.png";